import { createAction, props } from '@ngrx/store';
import {
  companyEditTypes,
  companyTypes,
} from '../../core/models/Interfaces/company';

export const companyDataSubmit = createAction(
  'company-details-submit',
  props<{ params: companyTypes }>(),
);
export const companyDataSubmitReceived = createAction(
  'company-details-received',
  props<{ params: any }>(),
);
export const companyDataSubmitFailed = createAction('company-details-failed');

export const companyEditDataSubmit = createAction(
  'update-company-details',
  props<{ params: companyEditTypes }>(),
);

export const fetchCompanyData = createAction(
  'fetch-company-details',
  props<{ sessionHash: string }>(),
);
export const fetchCompanyDataSuccessful = createAction(
  'fetch-company-details-success',
  props<{ params: any }>(),
);
export const fetchCompanyDataFailed = createAction(
  'fetch-company-details-failed',
);

// For list of owner cities
export const companyOwnerCities = createAction(
  'company-owner-cities',
  props<{ params: any }>(),
);
export const companyOwnerCitiesReceived = createAction(
  'company-owner-cities-received',
  props<{ params: any }>(),
);
export const companyOwnerCitiesFailed = createAction(
  'company-owner-cities-failed',
);

// About Contacts
export const getContacts = createAction('get-contacts');
export const getContactsReceived = createAction(
  'get-contacts-received',
  props<{ params: any }>(),
);

// Add Contacts
export const addContacts = createAction(
  'add-contacts',
  props<{ params: any }>(),
);
export const addContactsSuccessfull = createAction('add-contacts-successfull');
export const addContactsFailed = createAction('add-contacts-failed');

// Edit Contacts
export const editContacts = createAction(
  'edit-contacts',
  props<{ params: any }>(),
);
export const editContactsSuccessfull = createAction(
  'edit-contacts-successfull',
);
export const editContactsFailed = createAction('edit-contacts-failed');

// Delete Contacts
export const deleteContacts = createAction(
  'delete-contacts',
  props<{ params: any; contactId: number }>(),
);
export const deleteContactsSuccessfull = createAction(
  'delete-contacts-successfull',
);
export const deleteContactsFailed = createAction('delete-contacts-failed');

// About Address

// Get Address
export const getAddress = createAction('get-address');
export const getAddressReceived = createAction(
  'get-address-received',
  props<{ params: any }>(),
);
export const getAddressFailed = createAction('get-address-failed');

// Add Address
export const addAddress = createAction('add-address', props<{ params: any }>());
export const addAddressSuccessfull = createAction('add-address-successfull');
export const addAddressFailed = createAction('add-address-failed');

// Edit Address
export const editAddress = createAction(
  'edit-address',
  props<{ params: any }>(),
);
export const editAddressSuccessfull = createAction('edit-address-successfull');
export const editAddressFailed = createAction('edit-address-failed');

// Delete Address
export const deleteAddress = createAction(
  'delete-address',
  props<{ params: any; addressId: number }>(),
);
export const deleteAddressSuccessfull = createAction(
  'delete-address-successfull',
);
export const deleteAddressFailed = createAction('delete-address-failed');

// About Comments

// Get Comments
export const getComments = createAction('get-comments');
export const getCommentsReceived = createAction(
  'get-comments-received',
  props<{ params: any }>(),
);
export const getCommentsFailed = createAction('get-comments-failed');

// About City / State Permit

// Get City / State Permit
export const getCityPermits = createAction(
  'get-city-permits',
  props<{ permitId: number }>(),
);
export const getCityPermitsReceived = createAction(
  'get-city-permits-received',
  props<{ params: any }>(),
);
export const getCityPermitsFailed = createAction('get-city-permits-failed');

// Add City / State Permit
export const addCityPermits = createAction(
  'add-city-permits',
  props<{ params: any }>(),
);
export const addCityPermitsSuccessfull = createAction(
  'add-city-permits-successfull',
);
export const addCityPermitsFailed = createAction('add-city-permits-failed');

// Edit City / State Permit
export const editCityPermits = createAction(
  'edit-city-permits',
  props<{ params: any }>(),
);
export const editCityPermitsSuccessfull = createAction(
  'edit-city-permits-successfull',
);
export const editCityPermitsFailed = createAction('edit-city-permits-failed');

// Delete City / State Permit
export const deleteCityPermits = createAction(
  'delete-city-permits',
  props<{ params: any; cityPermitId: number; permitId: number }>(),
);
export const deleteCityPermitsSuccessfull = createAction(
  'delete-city-permits-successfull',
);
export const deleteCityPermitsFailed = createAction(
  'delete-city-permits-failed',
);

// About ACORD Certificate
// Get ACORD Certificate
export const getInsurancePolicy = createAction(
  'get-insurance-policy',
  props<{ permitId: number }>(),
);
export const getInsurancePolicyReceived = createAction(
  'get-insurance-policy-received',
  props<{ params: any }>(),
);
export const getInsurancePolicyFailed = createAction(
  'get-insurance-policy-failed',
);

// Add ACORD Certificate
export const addInsurancePolicy = createAction(
  'add-insurance-policy',
  props<{ params: any }>(),
);
export const addInsurancePolicySuccessfull = createAction(
  'add-insurance-policy-successfull',
);
export const addInsurancePolicyFailed = createAction(
  'add-insurance-policy-failed',
);

// Edit ACORD Certificate
export const editInsurancePolicy = createAction(
  'edit-insurance-policy',
  props<{ params: any }>(),
);
export const editInsurancePolicySuccessfull = createAction(
  'edit-insurance-policy-successfull',
);
export const editInsurancePolicyFailed = createAction(
  'edit-insurance-policy-failed',
);

// Delete ACORD Certificate
export const deleteInsurancePolicy = createAction(
  'delete-insurance-policy',
  props<{ params: any }>(),
);
export const deleteInsurancePolicySuccessfull = createAction(
  'delete-insurance-policy-successfull',
);
export const deleteInsurancePolicyFailed = createAction(
  'delete-insurance-policy-failed',
);

// Unviewed Count
export const getUnviewedCount = createAction('get-unviewed-count');
export const getUnviewedCountReceived = createAction(
  'get-unviewed-count-received',
  props<{ params: any }>(),
);
export const getUnviewedCountFailed = createAction('get-unviewed-count-failed');
